import { useCallback, useContext } from "react";
import { StateContext } from "../../../../context/globalContext/context";
import { iGlobalContext } from "../../../../context/globalContext/interface";
import { PromoDetailsResponse } from "../../../../types";
import { getPromoDetails } from "../../../../api/booking/promoReviewCart";

export const useAppPromoCode = () => {
  const { accessJWT, userInfo, onBoardForm, setOnBoardForm, promoCode, setPromoCode }: iGlobalContext =
    useContext(StateContext);

  const getPromoCode = useCallback(async () => {
    // /promos/search is auth-protected. Don't fire it before the (guest or
    // logged-in) token exists — fetchApi would send the request with no
    // x-access-token, which the backend can't authenticate.
    if (!accessJWT || !onBoardForm.signUpOffer || promoCode?.[0]?.description) {
      return;
    }
    const promo = onBoardForm.signUpOffer;
    const requestBody = {
      userId: userInfo?.id,
      promoCodes: [promo],
    };

    try {
      const response: PromoDetailsResponse = await getPromoDetails(accessJWT, requestBody);
      if (response?.statusCode === 200 && response?.data) {
        setPromoCode(response.data);
        setOnBoardForm((prevData) => ({ ...prevData, isOfferAvailable: false }));
      } else {
        // Promo code is invalid or API failed, clear it and mark as unavailable
        setPromoCode([]);
        setOnBoardForm((prevData) => ({ ...prevData, isOfferAvailable: true }));
      }
      return response;
    } catch (err) {
      console.warn("Promo code validation failed:", err);
      // Clear promo code on error to prevent app from being stuck
      setPromoCode([]);
      setOnBoardForm((prevData) => ({ ...prevData, isOfferAvailable: true }));
      return null;
    }
  }, [accessJWT, onBoardForm.signUpOffer, promoCode, setOnBoardForm, setPromoCode, userInfo?.id]);

  const updatePromoCode = useCallback(
    (promoCode?: string) => {
      if (!promoCode) return;

      setOnBoardForm((prev) => {
        if (prev.signUpOffer === promoCode) {
          return prev;
        }

        setPromoCode([]);

        return {
          ...prev,
          signUpOffer: promoCode,
        };
      });
    },
    [setOnBoardForm, setPromoCode]
  );

  return { getPromoCode, updatePromoCode };
};
